export default {
  provider: {
    categoryDesc: {
      ai_model:
        '配置和管理外部 AI 模型，包括大语言模型、Embedding、视觉模型等。',
      database: '配置和管理外部数据库，包括 MySQL、Redis、Milvus 等。',
      storage: '配置和管理云存储服务，包括阿里云 OSS、AWS S3、腾讯云 COS 等。',
      message: '配置和管理消息通道，包括邮件、钉钉、飞书、Slack 等。',
      web_search: '配置和管理网页搜索服务，包括 Google、Bing、SearXNG 等。',
      other: '配置和管理其他外部服务。',
    },
    // AI 模型提供商
    openai: {
      name: 'OpenAI',
      description: 'OpenAI API，支持 GPT-4、GPT-3.5、Whisper、DALL-E 等模型',
    },
    azure_openai: {
      name: 'Azure OpenAI',
      description: 'Microsoft Azure OpenAI Service',
    },
    anthropic: {
      name: 'Claude',
      description: 'Anthropic Claude 系列模型',
    },
    qwen: {
      name: '通义千问',
      description: '阿里云通义千问大模型及 AI 服务',
    },
    moonshot: {
      name: '月之暗面 Kimi',
      description: '月之暗面 Kimi 大语言模型',
    },
    google_gemini: {
      name: 'Google Gemini',
      description: 'Google Gemini 多模态模型',
    },
    ollama: {
      name: 'Ollama',
      description: '本地部署的开源模型（Llama、Mistral 等）',
    },
    volcengine: {
      name: '火山引擎',
      description: '火山引擎 AI 服务（豆包大模型、语音合成、语音识别等）',
    },
    minimax: {
      name: 'MiniMax',
      description: 'MiniMax AI 服务',
    },
    // 数据库提供商
    mysql: {
      name: 'MySQL',
      description: 'MySQL 关系型数据库',
    },
    postgresql: {
      name: 'PostgreSQL',
      description: 'PostgreSQL 数据库，支持 pgvector 向量扩展',
    },
    redis: {
      name: 'Redis',
      description: 'Redis 缓存数据库',
    },
    milvus: {
      name: 'Milvus',
      description: 'Milvus 向量数据库',
    },
    elasticsearch: {
      name: 'ElasticSearch',
      description: 'ElasticSearch 搜索引擎',
    },
    sqlite: {
      name: 'SQLite',
      description: 'SQLite 轻量级嵌入式数据库',
    },
    bytehouse: {
      name: 'ByteHouse',
      description: '火山引擎 ByteHouse 云原生数据仓库',
    },
    // 云存储提供商
    aliyun_oss: {
      name: '阿里云 OSS',
      description: '阿里云对象存储服务',
    },
    aws_s3: {
      name: 'AWS S3',
      description: 'Amazon S3 对象存储',
    },
    tencent_cos: {
      name: '腾讯云 COS',
      description: '腾讯云对象存储',
    },
    minio: {
      name: 'MinIO',
      description: 'MinIO 兼容 S3 的对象存储',
    },
    google_drive: {
      name: 'Google Drive',
      description: 'Google Drive 云盘',
    },
    onedrive: {
      name: 'OneDrive',
      description: 'Microsoft OneDrive 云盘',
    },
    dropbox: {
      name: 'Dropbox',
      description: 'Dropbox 云盘',
    },
    aliyun_drive: {
      name: '阿里云盘',
      description: '阿里云盘个人云存储',
    },
    baidu_pan: {
      name: '百度网盘',
      description: '百度网盘云存储',
    },
    webdav: {
      name: 'WebDAV',
      description: 'WebDAV 协议存储服务',
    },
    // 消息通道提供商
    email_smtp: {
      name: '邮件 (SMTP)',
      description: 'SMTP 邮件服务',
    },
    dingtalk: {
      name: '钉钉',
      description: '钉钉机器人 Webhook',
    },
    feishu: {
      name: '飞书',
      description: '飞书机器人 Webhook',
    },
    wechat_work: {
      name: '企业微信',
      description: '企业微信机器人 Webhook',
    },
    slack: {
      name: 'Slack',
      description: 'Slack Webhook',
    },
    telegram: {
      name: 'Telegram',
      description: 'Telegram Bot',
    },
    discord: {
      name: 'Discord',
      description: 'Discord Webhook',
    },
    aliyun_sms: {
      name: '阿里云短信',
      description: '阿里云短信服务',
    },
    tencent_sms: {
      name: '腾讯云短信',
      description: '腾讯云短信服务',
    },
    webhook: {
      name: 'Webhook',
      description: '通用 Webhook 推送',
    },
    // 网页搜索提供商
    google_search: {
      name: 'Google Custom Search',
      description: 'Google 可编程搜索引擎',
    },
    bing_search: {
      name: 'Bing Web Search',
      description: 'Microsoft Bing 网页搜索 API',
    },
    searxng: {
      name: 'SearXNG',
      description: 'SearXNG 开源元搜索引擎',
    },
  },
};
